import * as React from 'react';
import ToogleSwitch from 'src/components/common/ToggleSwitch';

import './AccountSubusersRow.scss';
import ToggleSwitch from 'src/components/common/ToggleSwitch';

interface IAccountSubusersRowProps {
  userId: string;
  account: string;
  fullName: string;
  email: string;
  enabledInvoices: boolean;
  manageInvoices(
    accountId: string,
    clientIdentity: string,
    allow: boolean
  ): any;
}

class AccountSubusersRow extends React.Component<
  IAccountSubusersRowProps,
  any
> {
  constructor(props: any) {
    super(props);
  }

  private onToggleChange = () => {
    this.props.manageInvoices(
      this.props.account,
      this.props.userId,
      !this.props.enabledInvoices
    );
  };

  public render() {
    const { props } = this;
    return (
      <div className="container-fluid rp-account-subusers-row">
        <div className="row">
          <div className="col-2">{props.account}</div>
          <div className="col-3">{props.fullName}</div>
          <div className="col">{props.email}</div>
          <div className="col-2 rp-account-subusers-row--toggle">
            <ToggleSwitch
              enabled={props.enabledInvoices}
              handleOnButtonChange={this.onToggleChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AccountSubusersRow;
